<template>
	<div class="c-newsletter">
		<div class="c-newsletter__form" v-if="!showSuccess">
			<FieldInput
				:id="'newsletterEmail'"
				:placeholder="translations['E-mail']"
				:required="true"
				schema="email"
				type="email"
				v-model="email"
				:error="error"
				:errorText="errorText"
				@focus="addKeyPress"
				@blur="removeKeyPress"
			></FieldInput>
			<button
				class="o-btn"
				@click="subscribe"
				:aria-label="translations['Sign up to newsletter']"
			>
				<Loader v-if="loading"></Loader>
				<span v-else>{{ translations['Sign up to newsletter'] }}</span>
			</button>
		</div>
		<div class="c-newsletter__success" v-else>
			<p>{{ translations['Thanks for signing up!'] }}</p>
		</div>
	</div>
</template>

<script>
import FieldInput from '@/vue/components/fields/FieldInput';
import request from '@/vue/mixins/request.js';
import Loader from '@/vue/components/objects/Loader.vue';

export default {
	name: 'Newsletter',
	mixins: [request],
	components: {
		FieldInput,
		Loader,
	},
	data: () => {
		return {
			email: '',
			showSuccess: false,

			error: false,
			errorText: '',
		};
	},
	watch: {
		emails(newValue, oldValue) {
			if ((newValue, oldValue)) {
				this.error = false;
				this.errorText = '';
			}
		},
	},
	methods: {
		subscribe() {
			const formData = new FormData();
			formData.append('action', this.action.newsletterSignup);
			formData.append('email', this.email);

			this.request(formData).then(() => {
				if (!this.res.data.success && this.res.data.message) {
					this.error = true;
					this.errorText = this.res.data.message;
				}

				if (this.res.data.success) {
					this.showSuccess = true;
				}
			});
		},

		keyDownHandler(e) {
			if (e.key == 'Enter') {
				this.subscribe();
			}
		},
		addKeyPress() {
			window.addEventListener('keydown', this.keyDownHandler);
		},
		removeKeyPress() {
			window.removeEventListener('keydown', this.keyDownHandler);
		},
	},
	destroyed() {
		window.removeEventListener('keydown', this.keyDownHandler);
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.c-newsletter {
	&__form {
		display: flex;
		gap: 16px;

		.o-input {
			flex: 2;
			margin-top: 0;
			label {
				background-color: transparent;
			}

			&__error {
				display: none;
			}
		}
		.o-btn {
			flex: 1;
			// margin-left: 16px;
			min-width: 213px;
			padding-inline: 10px;
		}
	}

	&__success {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;

		background-color: $c-white;
		border: $e-border;
	}
}

@media all and (max-width: 1150px) {
	.c-newsletter {
		&__form {
			flex-direction: column;
			gap: 8px;
			.o-btn {
				margin-left: 0px;
				min-width: 205px;
			}
		}
	}
}

@media all and (max-width: 455px) {
	.c-newsletter {
		&__form {
			flex-direction: column;
			.o-btn {
				margin-left: 0px;
				padding-left: 5px;
				padding-right: 5px;
				min-width: 190px;
			}
		}
	}
}
</style>
